import { Stack, Typography } from '@mui/material';
import { FieldRowLabel } from '@Components/shared/labels/FieldRowLabel';
import { useUserDrawer } from '@Modal/hooks/users/useUserDrawer';
import { ProvidersTableGames, ProvidersTableGamesKeys } from '@Modal/reducers/providers/types';
import TruncateText from '@Components/truncate-text/TruncateText';

export const UserDrawerDetails = () => {
  const { selectedUser } = useUserDrawer();
  const { id, email, roleIds, providerRgs, games } = selectedUser;
  const gamesAsString = games
    ?.map((game) => ProvidersTableGames[game as ProvidersTableGamesKeys])
    .join(', ');

  return (
    <Stack direction="column" spacing={3} sx={{ padding: '16px' }}>
      <FieldRowLabel label="ID" value={id ? id : 'No Result'} />
      <FieldRowLabel label="Email" value={email ? email : 'No Result'} />
      <FieldRowLabel label="Role ID" value={roleIds ? roleIds[0] : 'No Result'} />
      <FieldRowLabel label="Games" value={games ? gamesAsString : 'No Result'} />
      {providerRgs && providerRgs.length > 0 ? (
        <Stack direction="column" spacing={1}>
          {providerRgs.map(({ rgsId, providerIds }) => (
            <Stack key={rgsId} direction="column" spacing={0.5}>
              <Typography variant="subtitle2" fontWeight="bold">
                RGS: {rgsId}
              </Typography>
              <Stack direction="column" gap={2}>
                {providerIds.map((pid) => (
                  <TruncateText key={pid} text={pid} maxLength={16} />
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack>
      ) : (
        <Typography variant="body2">No RGS data</Typography>
      )}
    </Stack>
  );
};
